import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ThemeClient } from '../contexts/Theme';
import Navbar from '../Navbar';
import Logo from '../components/Logo'

import { supabase } from '../supabaseClient';

export default function UpdatePassword() {
  const history = useHistory();
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');

  const handleUpdatePassword = async () => {
    try {
      const { data, error } = await supabase.auth.updateUser({
        password: newPassword,
      });

      if (error) {
        console.log(error);
        if (error.message.includes('Password should be at least 6 characters')) {
          setError('La contraseña debe tener al menos 6 caracteres');
        } else if (error.message.includes('New password should be different from the old password')) {
          setError('La nueva contraseña debe ser diferente a la contraseña anterior');
        }
        
      } else {
        console.log(data); // Updated user data
        history.push('/login');
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <ThemeClient>
      <Navbar title={'Actualizar contraseña'} />

      <Logo
            style={{
                height: 'auto',
                maxWidth: '100%',
                marginTop: '2rem',
                marginBottom: '2rem',
            }}
        />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div>
          {error && (
            <Typography variant="body1" align="center" gutterBottom color="error">
              {error}
            </Typography>
          )}
          <Typography variant="body1" align="center" gutterBottom>
            Por favor, ingresa tu nueva contraseña:
          </Typography>
          <TextField
            margin="normal"
            required
            fullWidth
            name="newPassword"
            label="Nueva Contraseña"
            type="password"
            id="newPassword"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleUpdatePassword}
          >
            Enviar
          </Button>
        </div>
      </Container>
    </ThemeClient>
  );
}
